import {isLoggedIn} from '../../utils/auth'
import {injectReducer} from '../../store/reducers'
import {campaignDetailsReducer, batchRuleSourceReducer, saveCampaignReducer} from './modles/CampaignCreation'

export default (store) => ({
  path: 'campaign-creation/:rules/:data',
  onEnter: isLoggedIn(store),
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      const CampaignCreationContainer = require('./containers/CampaignCreation').default

      injectReducer(store, {key: 'campaignDetails', reducer: campaignDetailsReducer})
      injectReducer(store, {key: 'batchRuleSource', reducer: batchRuleSourceReducer})
      injectReducer(store, {key: 'savedCampaignDetails', reducer: saveCampaignReducer})
      cb(null, CampaignCreationContainer)
    }, 'campaignCreation')
  }
})



// WEBPACK FOOTER //
// ./src/routes/CampaignCreation/index.js